import { useEffect, useRef, useState } from "react";

export default function CurrencyDropdown({ currencies = [], onChange,setSelectedCurrency }) {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(currencies[0] || null);
  const containerRef = useRef();

  // Handle outside clicks to close dropdown
  useEffect(() => {
    function handleClickOutside(event) {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleDropdown = () => setIsOpen(prev => !prev);

  const selectCurrency = (currency) => {
    setSelected(currency);
    setSelectedCurrency(currency);  
    setIsOpen(false);
    if (onChange) onChange(currency);
  };

  return (
    <div className="relative inline-block text-left" ref={containerRef}>
      {/* Button to toggle dropdown */}
      <button
        type="button"
        onClick={toggleDropdown}
        className="inline-flex justify-between items-center w-48 px-4 py-2 bg-white border border-gray-300 rounded-lg shadow-sm hover:bg-gray-50 focus:outline-none"
      >
        {selected ? (
          <span className="flex items-center gap-2 font-bold">
            {/* <img src={selected.image} alt={selected.name} className="w-6 h-6 mr-2" /> */}
            <span className="text-base font-bold  text-gray-700">{selected.name}</span>

          </span>
        ) : (
          <span className="text-base font-bold text-gray-700">Select Currency</span>
        )}
        <svg
          className={`w-5 h-5 ml-2 transition-transform duration-200 ${isOpen ? 'transform rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {/* Dropdown list */}
      {isOpen && (
        <ul className="absolute z-10 mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-lg max-h-60 overflow-auto">
          {currencies.map(currency => (
            <li
              key={currency.id}
              onClick={() => selectCurrency(currency)}
              className="flex items-center gap-4 px-4 py-2 cursor-pointer hover:bg-gray-100"
            >
     
              <span className="text-base text-gray-700">{currency.name}</span>
              
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
